<template>
  <div :class="$setClasses">
    <nxt-resume v-if="demand"
                v-model="value"
                :disabled="disabled"
                :from-address="fromAddress"
                :from-date="clientLoadDate"
                :is-collapse="isCollapse === undefined ? true : isCollapse"
                :one-table="syncFormule"
                :to-address="toAddress"
                :to-date="clientDeliveryDate"
                :two-table="syncLeftToDo">
      <template v-slot:date-collapse-item>
        <slot name="collapse-items"></slot>
        <el-collapse-item v-if="insuranceData && !insuranceData.hidden"
                          :disabled="disabled || insuranceData.disabled"
                          name="insurance">
          <template v-if="isCollapse"
                    v-slot:title>
            <font-awesome-icon v-if="insuranceData.displayCheck"
                                :class="['resume__icon-check',
                                insuranceData.check ? '--is-check' : '']"
                                :icon="['fas',
                                insuranceData.check ? 'circle-check' : 'circle-xmark']"/>
            <font-awesome-icon v-if="insuranceData.icon !== false"
                                :class="'resume__icon'"
                                :icon="insuranceData.icon"/>
            <span :class="['resume__title', 'bold']">{{ insuranceData.title }}</span>
          </template>
          <nxt-table-card :class="$vClass('card')"
                          :hide-title="isCollapse"
                          :one-table="insuranceData"/>
        </el-collapse-item>
      </template>
      <template v-slot:after-collapse-item>
        <template v-if="offer">
          <el-collapse-item v-if="offerServices
            && offerServices.items
            && offerServices.items.length
            && !offerServices.hidden"
                            :disabled="disabled || offerServices.disabled"
                            name="services">
            <template v-if="isCollapse"
                      v-slot:title>
              <font-awesome-icon v-if="offerServices.displayCheck"
                                 :class="['resume__icon-check',
                                  offerServices.check ? '--is-check' : '']"
                                 :icon="['fas',
                                  offerServices.check ? 'circle-check' : 'circle-xmark']"/>
              <font-awesome-icon v-if="offerServices.icon !== false"
                                 :class="'resume__icon'"
                                 :icon="offerServices.icon || ['fal', 'truck']"/>
              <span :class="['resume__title', 'bold']">{{ offerServices.title }}</span>
            </template>
            <nxt-table-card :class="$vClass('card')"
                            :hide-title="isCollapse"
                            :one-table="offerServices">
            </nxt-table-card>
            <div v-if="chooseServices && chooseServices.length"
                 :class="$vClass('wrapper__services')">
              <card-flex v-for="(item, index) in chooseServices"
                         :icon="['fal', item.icon]"
                         :key="`service_${index}`"
                         :title="item.title"
                         class="is-chosen-service --margin-top --icon-size-lg">
                <p>{{item.subtitle}}</p>
                <template v-slot:after>
                  <b>{{ formatPrice(item.step
                      ? (item.value_chosen || 0) / item.step * item[priceType]
                      : item[priceType], demand.show_price_ht) }}</b>
                </template>
              </card-flex>
            </div>
          </el-collapse-item>
          <el-collapse-item v-if="offerOptions
            && offerOptions.items
            && offerOptions.items.length
            && !offerOptions.hidden"
                            :disabled="disabled || offerOptions.disabled"
                            name="options">
            <template v-if="isCollapse"
                      v-slot:title>
              <font-awesome-icon v-if="offerOptions.displayCheck"
                                 :class="['resume__icon-check',
                                  offerOptions.check ? '--is-check' : '']"
                                 :icon="['fas',
                                  offerOptions.check ? 'circle-check' : 'circle-xmark']"/>
              <font-awesome-icon v-if="offerOptions.icon !== false"
                                 :class="'resume__icon'"
                                 :icon="offerOptions.icon || ['fal', 'truck']"/>
              <span :class="['resume__title', 'bold']">{{ offerOptions.title }}</span>
            </template>
            <nxt-table-card :class="$vClass('card')"
                            :hide-title="isCollapse"
                            :one-table="offerOptions">
              <template v-if="!hidePriceInfo" v-slot:before-checkbox="{item}">
                {{ $n(getPrice(item), 'currency') }}
                {{ $tc('base.priceType', demand.show_price_ht) }}
              </template>
            </nxt-table-card>
          </el-collapse-item>
        </template>
      </template>
    </nxt-resume>
    <slot name="before-price"></slot>
    <total v-if="!hideTotalPrice && !hidePriceInfo && offer"
           :class="[$vClass('total'), '--margin-top']"
           :is-box="isBox"
           :offer="offer"
           :price="priceWithServices"
           :warning-price="!!warningVisible">
      <template v-if="isBox"
                v-slot:price="{scope}">
        <p :class="[$vClass('price'), 'total__price']">
          {{ scope }}
        </p>
        <p>{{ $t('resume.booking.guaranteedPrice') }}</p>
        <!--        <nxt-link v-if="offer.url"-->
        <!--                  :class="$vClass('price__link')"-->
        <!--                  :to="offer.url"-->
        <!--                  target="_blank">{{ $t('resume.booking.seePdf') }}</nxt-link>-->
      </template>
    </total>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CardFlex from '@/utils/components/CardFlex.vue';
import MoveManager from '@/utils/components/MoveManager.vue';
import Total from '@/utils/components/Total.vue';
import offersHelper from '@/utils/helpers/offers';

export default {
  name: 'quote',
  nameClassStyle: 'quote',
  extends: MoveManager,
  components: {
    CardFlex,
    Total,
  },
  props: {
    hideInfoMover: Boolean,
    hideTotalPrice: Boolean,
    isBox: Boolean,
    isCollapse: Boolean,
    disabled: Boolean,
    value: Array,
    checkboxOptions: Boolean,
    optionsType: String,
    collapseItems: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    ...mapGetters({
      comparatorConfig: 'configStore/comparatorConfig',
    }),
    chooseServices() {
      return this.servicesStore.filter((item) => (item.is_chosen));
    },
    price() {
      return this.offer
        ? offersHelper.getPrice(this.offer, this.demand.show_price_ht) : '';
    },
    priceWithServices() {
      return this.price + this.servicesPrice;
    },
    offerOptions() {
      const options = this.optionsType === 'chosen' ? this.chosenOptions : this.options;
      return {
        ...options,
        displayCheck: true,
        check: options.items.find((item) => item.is_chosen),
      };
    },
    syncLeftToDo() {
      return {
        ...this.leftToDo,
        displayCheck: true,
      };
    },
    syncFormule() {
      return {
        ...this.formule,
        displayCheck: true,
        check: true,
        ...this.collapseItems.formule,
      };
    },
    fromAddress() {
      return {
        ...this.demand.from_address,
        displayCheck: true,
        check: !!(this.demand.from_address && this.demand.from_address.street),
        ...this.collapseItems.fromAddress,
      };
    },
    toAddress() {
      return {
        ...this.demand.to_address,
        displayCheck: true,
        check: !!(this.demand.to_address && this.demand.to_address.street),
        ...this.collapseItems.toAddress,
      };
    },
    offerServices() {
      return this.offer && this.offer.services && {
        items: this.offer.services,
        ...this.servicesInfos,
        displayCheck: true,
        check: true,
        ...this.collapseItems.services,
      };
    },
    chosenOptions() {
      return this.offer && this.offer.options && {
        items: this.offer.options.filter((opt) => opt.is_chosen),
        ...this.chosenOptionsInfos,
      };
    },
    options() {
      return this.offer && this.offer.options && {
        items: this.offer.options,
        ...this.optionsInfos,
        check: !!(this.offer.options.find((opt) => opt.is_chosen)),
        displayCheck: true,
        checkbox: this.checkboxOptions,
        ...this.collapseItems.options,
      };
    },
    insuranceData() {
      if (this.offer && this.offer.assurance_type === 'AUCUNE') {
        return null;
      }
      return this.offer && this.offer.assurance && this.offer.franchise && {
        items: [this.offer.assurance, this.offer.franchise],
        ...this.insuranceInfos,
        displayCheck: true,
        check: true,
        ...this.collapseItems.insurance,
      };
    },
  },
  methods: {
    getPrice(option) {
      return this.exclTax ? option.price_ht : option.price;
    },
    formatPrice(price, priceType) {
      return `${this.$n(price, 'currency')} ${this.$tc('base.priceType', priceType)}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@nextories/vue-core-components/src/assets/scss/components/templates/Resume';

.quote {
  @include breakpoint(tablet) {
    .quote__wrapper {
      display: flex;
      align-items: center;

      &__title:not(:last-child) :after {
        content: '-';
        display: block;
        padding: 0 15px;
      }
    }
  }

  &__total {
    padding-bottom: 20px;
  }

  &__price {
    font-size: 26px;

    &__link {
      color: var(--nxt-color-primary);
      font-weight: normal;
      text-shadow: none;
    }
  }

  .--margin-top:not(.is-chosen-service:first-child) {
    margin-top: 20px;
  }

  .--icon-size-lg {
    :deep(.card-flex__icon) {
      font-size: 30px;
    }
  }

  &__card {
    margin-bottom: 20px;
  }

  :deep(.card-flex__title) {
    font-size: 22px;
  }

  :deep(.card-flex__content), :deep(.card-flex__wrapper) {
    font-size: 18px;
  }

  .loading {
    position: absolute;
    top: 0;
    left: 0;
  }

  :deep(.card-flex__img) {
    height: 100px;
  }

  :deep(.table__item__icon) {
    &.fa-times-circle, &.fa-circle-xmark {
      color: $--color-danger;
    }
  }
}

.loader {

  .loading-icon {
    :deep(.bar) {
      background: $--color-secondary;
    }
  }
}
</style>
